import React from 'react';
import styled from 'styled-components';

const SkeletonContainer = styled.div`
  width: 100%;
  padding: 40px 20px;
`;

const SkeletonSectionTitle = styled.div`
  width: 250px;
  height: 36px;
  margin: 0 auto 30px;
  background: linear-gradient(90deg, #9cc54b 25%, #8ab03f 50%, #9cc54b 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  @media (max-width: 768px) {
    width: 200px;
    height: 28px;
  }
`;

const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
`;

const SkeletonCard = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 30px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const SkeletonIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  margin: 0 auto 20px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
    margin-bottom: 15px;
  }
`;

const SkeletonText = styled.div`
  width: ${props => props.width || '100%'};
  height: 14px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 10px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

/**
 * ReviewSkeleton Component
 * 3 cards with icon centered at top + text below
 * Responsive layout: 3 cols desktop, 2 cols tablet, 1 col mobile
 */
const ReviewSkeleton = ({cardCount = 3}) => {
	return (
		<SkeletonContainer>
			<SkeletonSectionTitle/>
			<SkeletonGrid>
				{[...Array(cardCount)].map((_, index) => (
					<SkeletonCard key={`review-skeleton-${index}`}>
						<SkeletonIcon/>
						<SkeletonText width="80%"/>
						<SkeletonText width="100%"/>
						<SkeletonText width="90%"/>
						<SkeletonText width="70%"/>
					</SkeletonCard>
				))}
			</SkeletonGrid>
		</SkeletonContainer>
	);
};

export default React.memo(ReviewSkeleton);
